import React, { FC, useMemo } from "react";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import BeeBuffer from "./svg/beeBuffer";

const Loader: FC= () => {
    const domainData = useSelector((state: any) => state.getClubByDomain.domainResult); 
    let wingsColor 
    let bodyColor 
        
    if (domainData?.themeType) {
        document.documentElement.setAttribute('color-scheme', domainData.themeType);
    }
    if (domainData?.colorScheme ) {
        let colorScheme = domainData?.colorScheme;
            if (typeof colorScheme === 'number') {
                colorScheme = String(colorScheme);
                return null ;
            }
            if (colorScheme) {
                let hue, saturation, lightness;
                if (colorScheme.includes(',')) {
                    [hue, saturation, lightness] = colorScheme.split(',');
                } else {
                    hue = colorScheme;
                }
                wingsColor = `hsl(${hue}, 40%, 90%)`;
                bodyColor = `hsl(${hue}, 70%, 80%)`;
            }
    }else {
        wingsColor = `hsl(45 40%, 90%)`;
        bodyColor = `hsl(45, 70%, 80%)`;
    }

    return (
        <Modal className="svg-modal-spinner" centered mask={true} open={true} closable={false} closeIcon={false} footer={null}>
            <div className="svg-wrapper">
                <BeeBuffer wingsColor={wingsColor} bodyColor={bodyColor} width={300} height={300} />
            </div>
        </Modal>
    );
};

export default Loader;
